import { createFileRoute } from '@tanstack/react-router';
import { HomeRedirect } from '@/features/session';

/** The home: the page the admin came from, or the organisation list. */
export const Route = createFileRoute('/_auth/')({
  component: HomeRedirect,
});
